// extracted by mini-css-extract-plugin
export default {"ArchiveCheckbox":"styles_ArchiveCheckbox__O-fSo","archived":"styles_archived__Klk2N"};